export default "__VITE_ASSET__D7vk8y6q__"